import styled from 'styled-components';

const ImageWrapper = styled.div`
  & img {
    width: 100%;
  }
`;

export default ImageWrapper;
